import { FC } from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components/macro';

const DealerReportLoader: FC = () => {
  const theme = useTheme();

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={177}
      backgroundColor={theme.colors.white}
      foregroundColor={theme.colors.primary.variant6}
    >
      <rect x="10" y="10" rx="8" ry="8" width="265" height="150" />
      <rect x="295" y="10" rx="8" ry="8" width="265" height="150" />
      <rect x="580" y="10" rx="8" ry="8" width="265" height="150" />
      <rect x="865" y="10" rx="8" ry="8" width="265" height="150" />
      <rect x="1150" y="10" rx="8" ry="8" width="265" height="150" />
    </ContentLoader>
  );
};

export default DealerReportLoader;
